import React from 'react'
import { useAppDispatch } from '../../../../../hooks/redux'

import BaseModal from '../../../../../components/molecules/ChatModals/BaseModal'
import Button from '../../../../../components/atoms/Button2'
import RedButton from '@SonarCX/components/atoms/RedButton'
import EditableContent from './EditableContent'
import EndControls from '../../../../../components/molecules/ChatModals/EndControls'
import AreYouSureModal from '../../../../../components/molecules/ChatModals/AreYouSureModal'
import ErrorToast from '../../../../../components/molecules/ErrorToast'
import Banner from '../../../../../components/atoms/Banner'
import { useRolesPermissions } from '../../../../../providers/RolesPermissionsProvider'
import { AddSuccessAlert } from '../../../../../slices/alert'

import useStyles from './styles'

const RolesPermissionsModal = () => {
  const {
    setOpenModal,
    setData,
    setToSaveObject,
    updatingRoles,
    data,
    error,
    setError,
    removeRole
  } = useRolesPermissions()
  const dispatch = useAppDispatch()
  const classes = useStyles()

  const [permissionsArray, setPermissionsArray] = React.useState([])
  const [check, setCheck] = React.useState(false)
  const [saving, setSaving] = React.useState(false)

  React.useEffect(() => {
    setToSaveObject(obj => ({ ...obj, permissions: permissionsArray }))
  }, [permissionsArray, setToSaveObject])

  const handleDelete = React.useCallback(() => {
    try {
      removeRole(data.id).then(res => {
        if (res) {
          dispatch(AddSuccessAlert('Changes saved'))
          setOpenModal(false)
          setData({})
        }
      })
    } catch (err) {
      console.error('Error deleting role', err)
    }
  }, [data.id, removeRole, setData, setOpenModal, dispatch])

  const handleSave = React.useCallback(async () => {
    try {
      setSaving(true)
      const add = await updatingRoles()

      if (add) {
        dispatch(AddSuccessAlert('Changes saved'))
        setOpenModal(false)
        setData({})
      }
      setSaving(false)
    } catch (err) {
      console.error('Error updating roles', err)
    }
  }, [updatingRoles, setData, setOpenModal, dispatch])

  return (
    <>
      <BaseModal
        open={true}
        variant={'mobileRole'}
        showTitleOnMobile={true}
        onClose={() => {
          setOpenModal(false)
          setData({})
          setError(null)
        }}
        title={`${data.id ? 'EDIT' : 'ADD'} ROLE`}
        PaperProps={{ style: { top: '53%', width: '50%' } }}
      >
        {data.system && (
          <Banner className={classes.banner}>
            {' '}
            This is a system role, it cannot be edited{' '}
          </Banner>
        )}
        <EditableContent setPermissionsArray={setPermissionsArray} />

        {data.system ? (
          <EndControls
            onSubmit={() => {
              setOpenModal(false)
              setData({})
            }}
            submitText='CLOSE'
            showExtraIcons={false}
            SubmitIcon={() => null}
          />
        ) : (
          <div className={classes.controls}>
            {Boolean(Object.keys(data)?.length) && (
              <RedButton
                className={classes.button}
                onClick={() => setCheck(true)}
              >
                DELETE
              </RedButton>
            )}

            <Button
              onClick={handleSave}
              loading={saving}
              className={classes.button}
            >
              SAVE
            </Button>
          </div>
        )}
      </BaseModal>

      {error && <ErrorToast error={error} />}

      {check && (
        <AreYouSureModal
          open={check}
          onClose={() => setCheck(false)}
          onAccept={handleDelete}
          reason={'Are you sure you want to delete this role?'}
          subtext={'This change will take immediate affect to the system'}
        />
      )}
    </>
  )
}

export default RolesPermissionsModal
